<template>
    <v-container>
        <BackButton containerClass="lg10"/>
        <div v-if="getIsCheckinGuest" class="member__confirm">
            <div class="member__confirm__icon">
                <svg-icon name="confirmCreateClient" :width="80" :height="80"/>
            </div>

            <div class="title-h4">{{$t('studio.new-member.confirm_title')}}</div>
            <div class="member__confirm-subtitle">{{$t('studio.new-member.confirm_subtitle')}}</div>
            <div class="member__confirm-text">{{$t('studio.new-member.confirm_email', { email: newMember.email })}}</div>
            <div class="member__confirm-text">{{$t('studio.new-member.confirm_spam')}}</div>
            <button
                @click="registerAnotherMember"
                class="btn btn-m btn-gradient member__confirm-button"
            >
                <span>{{$t('studio.new-member.confirm_button')}}</span>
            </button>
        </div>

        <v-flex lg10 class="mx-auto" v-else>
            <div class="attention">
                                <div class="attention__pic"><img src="@/assets/images/dashboard/info.svg" alt=""></div>
                                <div class="attention__text" v-html="$t('studio.new-member.description')"></div>
            </div>

            <div class="d-flex flex-column">

                <v-flex lg9>
                    <div class="d-flex member__first-row justify-space-between member__row">
                        <v-flex lg5 sm5>
                            <SimpleInput
                                v-model="newMember.first_name"
                                :v="$v.newMember.first_name"
                                :placeholder='$t("studio.new-member.first_name_title")'
                                :title='`*${$t("studio.new-member.first_name_title")}`'
                                class="member__input"
                            />
                        </v-flex>
                        <v-flex lg5 sm5>
                            <SimpleInput
                                v-model="newMember.last_name"
                                :v="$v.newMember.last_name"
                                :placeholder='$t("studio.new-member.last_name_title")'
                                :title='`*${$t("studio.new-member.last_name_title")}`'
                                class="member__input"
                            />
                        </v-flex>
                    </div>
                </v-flex>

                <v-flex lg9>
                    <div class="d-flex member__second-row justify-space-between member__row">
                        <v-flex lg5 sm5 class="member__dropdown">
                            <div class="member__title">*{{$t("studio.new-member.gender_title")}}</div>
                            <Dropdown
                                    :v="$v.newMember.gender"
                                    :list='[$t("studio.new-member.gender_male"), $t("studio.new-member.gender_female")]'
                                    :placeholder='$t("studio.new-member.gender_placeholder")'
                                    @update="updateGenderHandler"
                                    :is-need-watch="false"
                            />
                        </v-flex>
                        <v-flex lg5 sm5>
                            <SimpleInput
                                v-model="newMember.email"
                                :v="$v.newMember.email"
                                :placeholder='$t("studio.new-member.email_title")'
                                :title='`*${$t("studio.new-member.email_title")}`'
                                class="member__input"
                            />
                        </v-flex>
                    </div>
                </v-flex>


                <v-flex lg9>
                    <div class="d-flex align-center justify-space-between member__row member__row-button">
                        <v-flex lg4 class="member__required" lg5 sm5>
                            {{$t("studio.new-member.required_title")}}
                        </v-flex>

                        <v-flex lg5 sm5 xs12>
                            <button
                                    @click="registerMemberHandler"
                                    :disabled="isDisabledButton"
                                    class="btn btn-sm btn-gradient"
                                    style="width: 100%"
                            >
                        <span>
                            {{$t("studio.new-member.register_button")}}
                        </span>
                            </button>
                        </v-flex>
                    </div>
                </v-flex>
            </div>
        </v-flex>


    </v-container>
</template>

<script>
    import { mapGetters } from "vuex";
    import SimpleInput from "../../elements/SimpleInput";
    import Dropdown from "../../elements/Dropdown";
    import validate from "@/mixins/validate";
    import { createClient } from "@/api/studioServices";

    export default {
        components: {
            SimpleInput,
            Dropdown,
        },

        mixins: [validate],

        data() {
            return {
                newMember: {
                    first_name: '',
                    last_name: '',
                    email: '',
                    gender: ''
                }
            }
        },

        computed: {
            ...mapGetters([
                'getIsCheckinGuest'
            ]),

            isDisabledButton() {
                return this.$v.newMember.$invalid
            }
        },

        methods: {
            updateGenderHandler(value) {
                this.newMember.gender = value;
            },

            registerAnotherMember() {
                this.$set(this.newMember, 'email', '');
                this.$set(this.newMember, 'first_name', '');
                this.$set(this.newMember, 'last_name', '');
                this.$set(this.newMember, 'gender', '');

                this.$store.commit('SET_IS_CHECKIN_GUEST', false);
                this.$v.newMember.$reset();
            },

            async registerMemberHandler() {
                const { gender, email, first_name, last_name } = this.newMember;

                const data = {
                    gender: gender === this.$t("studio.new-member.gender_male") ? 1 : 2,
                    email,
                    first_name,
                    last_name,
                };

                try {
                    await createClient(data);

                    this.$store.commit('SET_IS_CHECKIN_GUEST', true);
                } catch (e) {
                    let resp = e.response;
                    if(resp.status === 422 && resp.data.error) {
                        let errors = resp.data.errors;
                        Object.keys(errors).forEach(key => {
                            this.$store.dispatch('ADD_ALERT', {type: "error", text: errors[key][0]})
                        })
                    }
                }
            },
        },

        beforeDestroy() {
            this.$store.commit('SET_IS_CHECKIN_GUEST', false);
        }
    }
</script>

<style lang="sass" scoped>
.member
    &__confirm
        margin: 0 auto
        max-width: 525px
        text-align: center

        &__icon
            position: relative
            left: 50%
            transform: translateX(-50%)
            width: 88px
            height: 88px
            border-radius: 50px
            background: rgba(#00CC83, 0.08)
            margin-bottom: 32px

        &-text
            +reg
            margin-top: 4px

        &-subtitle
            +medium
            margin: 15px 0 4px

        &-text,
        &-subtitle
            font-size: $font-size--m
            letter-spacing: 0.5px
            color: $color--dark

        &-button
            width: 343px
            margin-top: 36px

            +r(599)
                width: auto

    &__top
        margin: 16px 0 32px 0
        +r(599)
            flex-direction: column
            margin-bottom: 24px


    &__description
        margin-left: 12px
        +reg
        font-size: 14px
        letter-spacing: 0.005em
        color: $color--dark-lighten
        line-height: 20px

        +r(599)
            margin-left: 0
            margin-top: 10px
            text-align: justify

        &-bold
            +bold

    &__title
        +medium
        margin-bottom: 8px
        font-size: 16px
        color: $color--dark

    &__required
        +reg
        font-size: 16px
        color: $color--dark-lighten

        +r(599)
            margin-bottom: 40px
    &__first-row
        margin-top: 32px

        +r(599)
            margin-top: 24px

    &__second-row
        margin: 24px 0 40px

        +r(599)
            margin: 0

    &__dropdown, &__input
        +r(599)
            padding-bottom: 16px



    &__row
        +r(599)
            flex-direction: column

        &-button
            +r(599)
                align-items: normal !important

.info__icon
    position: relative
    min-width: 28px
    min-height: 28px
    border-radius: 50%
    border: 1px solid #ECC744

    &-ellipse
        position: absolute
        left: 50%
        top: 24%
        transform: translateX(-50%)
        width: 2px
        height: 9px
        border-radius: 50px
        background: #ECC744

    &-circle
        position: absolute
        left: 50%
        top: 70%
        transform: translateX(-50%)
        width: 3px
        height: 3px
        border-radius: 50%
        border: 0.85px solid #ECC744

.icon-confirmCreateClient
    height: 80px
    width: 80px
    position: absolute
    left: -8px
    bottom: -8px
</style>